export const useSxStyles = () => {
  return {
    autoComplete: {
      '& .MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
        padding: 0,
        paddingRight: '30px',
        '& .MuiAutocomplete-endAdornment': {
          right: 0,
        },
        '& .MuiAutocomplete-input': {
          padding: '3px 6px',
          fontSize: '14px',
        },
      },
      '& .MuiButtonBase-root.MuiChip-root': {
        height: '21px',
        borderRadius: '3px',
        '& .MuiChip-deleteIcon': {
          fontSize: '16px',
        },
      },
    },
  };
};
